import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import axios from "../../../../../../server/interceptors";
import {apiPsychUrl, apiLevelsUrl, DEFAULT_LANGUAGE} from '../../../../../../config';
import { FormattedMessage } from 'react-intl';
import SessionManager from "../../../../../../utils/authHandling/session-manager";

class QuizLevelSelection extends Component{
  constructor(props){
    super(props);
    this.state={
      psychFromRequest: [],
      levelsFromRequest: [],
      selectedPsych: "",
      selectedLevel: ""
    }
    this.getPsychRequest = this.getPsychRequest.bind(this);
    this.getLevelRequest = this.getLevelRequest.bind(this);
    this.selectPsych = this.selectPsych.bind(this);
    this.selectLevel = this.selectLevel.bind(this);
  }

  getPsychRequest(){
    return new Promise((resolve, reject) => {
      axios.get(apiPsychUrl, {
        headers: {
          'Content-Type': 'application/json',          
        }}).then(function (response){
        if(response.status === 200 || response.status === 201){
          resolve(response.data);
        }
      }).catch(error => {
        reject(error);
      });
    });
  }

  getLevelRequest(){
    return new Promise((resolve, reject) => {
      axios.get(apiLevelsUrl + "/" + this.state.selectedPsych, {
        headers: {
          'Content-Type': 'application/json',          
        }}).then(function (response){
        if(response.status === 200 || response.status === 201){
          resolve(response.data);
        }
      }).catch(error => {
        reject(error);
      });
    });
  }

  selectPsych(value){
    this.setState({
      selectedPsych: value
    }, function(){
      this.getLevelRequest().then(result => {
        const levels = result.TaxonomyLevels.map(item => ({Name: item.TaxLevelName, Id: item.Id}));
        this.setState({
          levelsFromRequest: levels
        });
      });
    });
  }

  selectLevel(value, levelString){
    this.props.changeLevel(value, levelString, this.state.selectedPsych);
  }

  componentDidMount(){
    this.getPsychRequest().then(result => {
      const psych = result.TaxonomyPsych.map(item => ({Name: item.PsychName, Id: item.Id}));
      this.setState({
        psychFromRequest: psych
      });
    });
  }

  componentDidUpdate(prevProps){
    if(prevProps.language !== this.props.language){
      this.getPsychRequest().then(result => {
        const psych = result.TaxonomyPsych.map(item => ({Name: item.PsychName, Id: item.Id}));
        this.setState({ psychFromRequest: psych });
      });
      if(this.state.selectedPsych){
        this.getLevelRequest().then(result => {
          const levels = result.TaxonomyLevels.map(item => ({Name: item.TaxLevelName, Id: item.Id}));
          this.setState({ levelsFromRequest: levels });
        });
      }
    }
  }


  render(){
    return(
      <div>
        <br/>
        <h5><FormattedMessage id="cl-select-psych"/></h5>
        <Form className="checklist">
          <Form.Group>
            {this.state.psychFromRequest.map((item, index) => {
              return( 
                <Form.Check
                  inline
                  key={index}
                  label={item.Name}
                  name="radioButton"
                  type="radio"
                  checked={this.state.selectedPsych === item.Id}
                  onChange={() => this.selectPsych(item.Id)}
                />
              )
            })}
          </Form.Group>
        </Form>
        <Form className="checklist">
          <Form.Group>
            {this.state.levelsFromRequest.map((item, index) => {
              return( 
                <Form.Check
                  inline
                  key={index}
                  label={item.Name}
                  name="radioButton"
                  type="radio"
                  onClick={() => this.selectLevel(item.Id, item.Name)}
                  checked={this.props.currentSelection === item.Id}
                  onChange={() => this.selectLevel(item.Id, item.Name)}
                />
              )
            })}
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default QuizLevelSelection;